import { persistReducer } from 'redux-persist';
import { localAppStorage } from '../root/local-storage';
import { commonDataReducer, commonDataSlice } from './common-slice';

const commonDataPersistConfig = {
  key: commonDataSlice.name,
  storage: localAppStorage,
  whitelist: ['extraDetails', 'recordData', 'queryData', 'queryThread'],
};

export const persistedCommonDataReducer = persistReducer(
  commonDataPersistConfig,
  commonDataReducer
);
